import { BigNumber } from 'bignumber.js'

import { WalletAssetsMarketCapCell } from '@root/entities/wallet/ui/table/column/wallet-asset-column/wallet-assets-market-cap-cell'
import { useOptionalAtom } from '@root/shared/lib'

import type { WalletAssetModel } from '@root/entities/wallet'

type Props = {
  asset: WalletAssetModel
}

export const WalletAssetsTableMarketCapCell: React.FC<Props> = ({ asset }) => {
  const marketCapUsd = useOptionalAtom(asset.pair?.marketCapUsd) ?? BigNumber(0)

  return (
    <WalletAssetsMarketCapCell
      currency={asset.currency}
      marketCapUsd={marketCapUsd}
    />
  )
}
